<template>
  <div class="box">
    <section-header :collapsed="isSectionCollapsed"  v-on:collapsed-status-changed="(val) => isSectionCollapsed = val" title="Service Videos"></section-header>
    <div class="columns is-multiline">
      <div class="column is-12 no-h-padding">
        <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage"></error-display-component>
        <b-table
          :data="serviceVideos"
          :sortable="false"
          :selecteable="false"
          :mobile-cards="false">
          :row-class="() => 'service-request-row'">
          <template slot-scope="props">
            <b-table-column field="" label="Status">
              <i class="grid-icon fa-fw fal fa-car-crash fa-lg has-text-danger" title="Damage recorded" :class="getDamageColorClassByServiceVideo(props.row)" v-if="props.row.isDamaged"/>
            </b-table-column>

            <b-table-column field="createdBy" label="Created By">
              {{ props.row.createdByCompact }}
            </b-table-column>

            <b-table-column field="createdAt" label="Created At">
              {{ props.row.createdAt | formatDateOnly }}
            </b-table-column>

            <b-table-column field="id" label="Actions">
              <video-player-control :url="props.row.fileLocation" :title="'Created by ' + props.row.createdBy" v-if="props.row.fileLocation"></video-player-control>
              <span class="icon" v-if="props.row.attachments && props.row.attachments.length">
                <i class="fal fa-lg fa-images" title="View Images" @click="onViewServiceVideoImages(props.row.id)"></i>
              </span>
              <span class="icon" v-if="props.row.fileLocation"><i class="fal fa-lg fa-download" @click.stop.prevent="onDownloadServiceVideo(props.row)" title="Download"></i></span>
              <service-media-request-action :isListMode="true" :serviceMediaItem="props.row" :vehicleName="vehicleName"></service-media-request-action>
            </b-table-column>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="has-text-centered">
                <p><b-icon icon="emoticon-sad" size="is-large"></b-icon></p>
                <p>No service videos created for this vehicle.</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>

import utilitiesMixin from '@/mixins/generic/utilities'
import { createNamespacedHelpers } from 'vuex'
import serviceVideoService from '@/services/serviceVideoService'
import VideoPlayerControl from '@/components/generic/VideoPlayerControl.vue'
import SectionHeader from '@/components/generic/SectionHeader'
import ServiceMediaRequestAction from '@/components/generic/ServiceMediaRequestAction'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'

const mapUserGetters = createNamespacedHelpers('user').mapGetters
const mapConfigGetters = createNamespacedHelpers('config').mapGetters
const mapDealerState = createNamespacedHelpers('dealer').mapState

export default {
  name: 'ServiceVideoContainer',
  inject: {
    $validator: '$validator'
  },
  mixins: [utilitiesMixin],
  components: {
    'video-player-control': VideoPlayerControl,
    'section-header': SectionHeader,
    'service-media-request-action': ServiceMediaRequestAction,
    'error-display-component': ErrorDisplayComponent
  },
  props: {
    vinNo: {
      type: String,
      default: ''
    },
    collapsed: {
      type: Boolean,
      default: true
    },
    vehicleName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isSectionCollapsed: this.collapsed,
      currentVinNo: '',
      serviceVideos: [],
      isLoading: false,
      serverErrors: [],
      serverErrorMessage: ''
    }
  },
  computed: {
    ...mapDealerState(['currentDealer']),
    ...mapUserGetters(['hasFeatureAccess', 'currentUser']),
    ...mapConfigGetters(['definedTypes']),
    hasVinNo: function () {
      if (this.vinNo) {
        return true
      }
      return false
    },
    dealerId: function () {
      return this.$store.state.dealer.currentDealer.id
    }
  },
  watch: {
    isSectionCollapsed: function (newValue, oldValue) {
      if (newValue === false) {
        this.fetchServiceVideos()
      }
    }
  },
  methods: {
    getDamageColorClassByServiceVideo: function (serviceVideo) {
      var result = 'has-text-grey-light'
      if (serviceVideo.isDamaged) {
        result = 'has-text-danger'
      }
      let classToAttach = {}
      classToAttach[result] = true
      return classToAttach
    },
    onDownloadServiceVideo: function (row) {
      window.location = row.fileLocation
    },
    onViewServiceVideoImages: function (id) {
      const serviceVideo = this.serviceVideos.find((x) => x.id === id)
      const images = (serviceVideo && serviceVideo.attachments ? serviceVideo.attachments : []).map((x) => x.fileLocation)
      if (images.length === 0 || typeof this.$viewerApi !== 'function') {
        return
      }
      this.$viewerApi({
        images: images,
        options: {
          title: true
        }
      })
    },
    reset: function () {
      this.serviceVideos = []
    },
    fetchServiceVideos: function () {
      this.reset()
      this.currentVinNo = this.vinNo
      this.isLoading = true
      this.serverErrorMessage = ''
      let that = this

      serviceVideoService.getServiceVideosByVin(this.currentVinNo, this.dealerId).then(response => {
        that.isLoading = false
        if (response.errors) {
          that.serverErrors = response.errors
        } else {
          that.serviceVideos = response.results
        }
      }).catch((error) => {
        that.isLoading = false
        that.serverErrorMessage = error.message
      })
    }
  }
}
</script>

<style scoped>

  .columns {
    padding-bottom: 0 !important;
    margin-bottom:0 !important;
  }

  .modal-card-head, .modal-card-foot {
    padding: 20px !important;
  }

  .modal-card {
    overflow: auto;
    width: 40vw;
  }

  .main-dialog-footer {
    display:flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: stretch;
    height:auto;
  }

  @media screen and (max-width: 500px) {
    .main-dialog-footer {
      height:120px;
    }
  }

  .modal-info-body {
    position:relative;
    max-height: calc(100vh - 220px);
    height: 60vh !important;
    overflow-y: auto;
    background: white;
  }

  .wire-payment-row {
    text-align: left;
    vertical-align:middle;
  }

  .wire-payment-column {
    text-align: left;
    vertical-align:middle;
  }
</style>
